import review from "./Review.module.css"

function Review ({
    pfp = "/assets/reviews/.png",
    name = "Name Surname",
    position = "Working Position",
    p = "Lorem ipsum dolor sit amet consectetur. Vestibulum sodales gravida risus ut. Habitant adipiscing tempus in neque lacus faucibus. Duis quam non a imperdiet vitae tempus pulvinar. Pellentesque senectus hac neque fringilla lacus viverra nibh blandit accumsan.",
    width = "15.2083svw"
}) {
    return (
        <main id={review.review} style={{ width }}>
            <div className={review.info}>
                <img className={review.img} src={pfp || '/assets/reviews/default.jpg'} alt={name} />
                <div className={review.description}>
                    <h1 className={review.name}>{name}</h1>
                    <h3 className={review.position}>{position}</h3>
                </div>
            </div>
            <p className={review.p}>{p}</p>
        </main>
    );
}

export default Review;
